module.exports = __webpack_public_path__ + "img/score_8.35c60a8e.png";